{
    "UnreturnedCallsFilterSectionTitle": "Filteren van niet-beantwoorde oproepen",
    "UnreturnedCallsFilterSectionDesc": "U kunt ook bepalen welke soorten inkomende oproepen worden opgenomen in de rapporten 'Niet-beantwoorde verloren oproepen'.",
    "UnreturnedCallsFilter_IncludeEscapedLabel": "Ontsnapt aan gesprekken opnemen:",
    "UnreturnedCallsFilter_IncludeDivertedOverflowedLabel": "Inclusief doorgeschakelde\/overgelopen oproepen:",
    "UnreturnedCallsFilter_IncludeTransferredLabel": "Inclusief doorgeschakelde oproepen:",
    "UnreturnedCallsFilter_IncludeAllOtherLabel": "Neem alle andere oproepen mee:",
    "NAME": "UnreturnedCallsFilter"
}